import React from 'react';
import {
  GiFarmTractor,
  GiFertilizerBag,
  GiWaterDrop,
  GiSprout,
  GiFruitBowl,
  GiWheat,
  GiThreeLeaves,
  GiPlantRoots,
} from 'react-icons/gi';
import { FaLeaf } from 'react-icons/fa';
import Reveal from '../Reveal/Reveal';
import '../../styles/process.css';

/* Faint decorative nature watermarks */
const DECOR = [
  { Icon: FaLeaf, cls: 'p1' },
  { Icon: GiWheat, cls: 'p2' },
  { Icon: GiThreeLeaves, cls: 'p3' },
  { Icon: GiPlantRoots, cls: 'p4' },
  { Icon: GiWheat, cls: 'p5' },
  { Icon: GiThreeLeaves, cls: 'p6' },
];

const PUB = process.env.PUBLIC_URL;

/* Step images live in public/process/ as 1.jpg … 5.jpg */
const STEPS = [
  {
    icon: <GiFarmTractor />,
    title: 'Land Preparation',
    desc: 'Reviving the soil naturally, restoring its structure and fertility.',
    img: `${PUB}/process/1.jpg`,
  },
  {
    icon: <GiFertilizerBag />,
    title: 'Natural Compost',
    desc: 'Enriching the earth with farm-made inputs — panchagavya, jeevamirtham, fish amino acid, vermicompost and more.',
    img: `${PUB}/process/2.jpg`,
  },
  {
    icon: <GiWaterDrop />,
    title: 'Water Management',
    desc: 'Mindful irrigation that conserves every precious drop.',
    img: `${PUB}/process/3.jpg`,
  },
  {
    icon: <GiSprout />,
    title: 'Nurturing Growth',
    desc: 'Tending each sapling with care as it grows strong and healthy.',
    img: `${PUB}/process/4.jpg`,
  },
  {
    icon: <GiFruitBowl />,
    title: 'Fresh Harvest',
    desc: 'Hand-picking naturally ripened fruit at the peak of goodness.',
    img: `${PUB}/process/5.jpg`,
  },
];

const FALLBACK =
  'https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?auto=format&fit=crop&w=500&q=70';

export default function FarmingProcess() {
  return (
    <section id="process" className="section process">
      <div className="process__decor" aria-hidden="true">
        {DECOR.map(({ Icon, cls }) => (
          <Icon key={cls} className={`process__leaf ${cls}`} />
        ))}
      </div>

      <div className="container">
        <Reveal className="section-head">
          <h2 className="section-title">From soil to your table</h2>
          <p className="section-subtitle">
            Every step honours nature — a transparent journey from healthy soil
            to your family's plate.
          </p>
        </Reveal>

        <div className="process__timeline">
          <div className="process__line" aria-hidden="true" />
          {STEPS.map((s, i) => (
            <Reveal
              key={s.title}
              delay={Math.min((i % 3) + 1, 5)}
              as="div"
              className="process-step"
            >
              <div className="process-step__photo">
                <img
                  src={s.img}
                  alt={s.title}
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.src = FALLBACK;
                  }}
                />
              </div>
              <div className="process-step__icon">{s.icon}</div>
              <h3 className="process-step__title">{s.title}</h3>
              <p>{s.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
